<div class="container-capped ">
  <div class="py-2">
    <a class="btn btn-primary btn-sm" (click)="open();editModal.open()">جدید</a>

  </div>
  <div *ngFor="let adv of advertises">
    <div class="kp-card">
      <div class="d-flex align-items-center  mb-2">
        <h5>{{adv.Title || adv.Id}}</h5>
        <div class="d-flex mr-auto">
          وضعیت: <select [(ngModel)]="adv.Status" (change)="save(adv)">
            <option [value]="0">فعال</option>
            <option [value]="1">بدون آگهی</option>
            <option [value]="2">غیرفعال</option>
          </select>
        </div>
      </div>
      <div *ngIf="adv.Banner" class="relative" style="height:130px">
        <div class="mask-local-light z-1" ></div>
        <div class="overflow-hidden" style="height: 260px;transform: scale(0.5);transform-origin: top;margin-bottom:-130px;" [innerHTML]="adv.Banner"></div>
      </div>
      <div class="d-flex flex-wrap align-items-center mt-2 fs-sm f-gray">
        <div *ngIf="adv.State" class="ml-2">
          <i class="fa fa-map-marker-alt ml-1"></i>
          <span>{{adv.State}}</span>
          <span *ngIf="adv.City"> - {{adv.State}}</span>
        </div>
        <div *ngIf="adv.JobTitles?.length">
          <span class="ml-1" *ngFor="let item of adv.JobTitles">#{{item}}</span>
        </div>
          
        
        <a class="btn btn-secondary btn-sm fs-sm mr-auto" (click)="open(adv);editModal.open()">ویرایش</a>
      </div>
    </div>
  </div>
</div>
<ngx-smart-modal #editModal identifier="editModal" customClass="">
  <div class="container-capped" *ngIf="editModal.visible && advertise">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h6>عنوان</h6>
      <div class="flex-grow-1 mr-3">
        <input type="text" name="title" [(ngModel)]="advertise.Title" />
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h6>وزن</h6>
      <div>
        <input type="number" min="0" max="100" name="weight" [(ngModel)]="advertise.Weight" />
      </div>
    </div>
    <div>
      <h6>بنر</h6>
      <angular-editor name="banner" [(ngModel)]="advertise.Banner"></angular-editor>
    </div>
    <div>
      <h6>بنر در جزئیات</h6>
      <angular-editor name="detail-banner" [(ngModel)]="advertise.DetailBanner"></angular-editor>
    </div>
    <div class="kp-card">
      <h6>شرایط نمایش:</h6>
      <div class="form-group clearfix">
        <h6>شهر:</h6>
        <app-location name="location" accept-level="Globe" [(ngModel)]="advertise"></app-location>
      </div>
      <div class="form-group">
        <h6>عناوین شغلی</h6>
        <ng-select name="jobTitles" [multiple]="true" [addTag]="true" [items]="[]"
          [(ngModel)]="advertise.JobTitles"></ng-select>
      </div>
    </div>
    <div class="kp-card">
      <div class="form-group clearfix">
        <h6>لینک ثابت:</h6>
        <input type="text" name="link" dir="ltr" [(ngModel)]="advertise.Link" />
        <br/>
        <div class="mt-1">
          <input type="checkbox" name="setUtm" [(ngModel)]="advertise.SetLinkUtm"> ست کردن utm
        </div>
      </div>
      <h6>آگهی‌ها:</h6>
      <div class="form-group clearfix">
        <h6>Id آگهی‌ها:</h6>
        <ng-select name="jobIds" [multiple]="true" [addTag]="true" [items]="[]"
          [(ngModel)]="advertise.Criteria.IncludedIds"></ng-select>
      </div>
      <div class="form-group clearfix">
        <h6>Id کارفرماها:</h6>
        <ng-select name="employerIds" [multiple]="true" [addTag]="true" [items]="[]"
          [(ngModel)]="advertise.Criteria.EmployerIds"></ng-select>
      </div>
    </div>
    <div class="white-bg p-2 sticky-bottom text-left">
      <a class="btn btn-link ml-3" (click)="advertise=null;editModal.close()">انصراف</a>
      <a class="btn btn-primary" (click)="save();editModal.close()">ذخیره</a>
    </div>
  </div>
</ngx-smart-modal>